// Contextual meal-type picker based on the local hour of day.
// Used when the user logs a food via voice quick-search without picking a
// specific meal slot — we make an educated guess so the log lands in the
// right bucket without an extra tap.
//
// Windows are inclusive of the lower bound, exclusive of the upper bound.
export function defaultMealTypeForNow(date = new Date()) {
  const h = date.getHours();
  if (h >= 5 && h < 10) return "colazione";
  if (h >= 10 && h < 12) return "spuntino";
  if (h >= 12 && h < 15) return "pranzo";
  if (h >= 15 && h < 18) return "merenda";
  if (h >= 18 && h < 23) return "cena";
  return "spuntino"; // late-night or very-early — default to snack
}

// If the contextual default was wrong, which single alternative is most likely?
// Rules of thumb: near the boundary of a bucket, suggest the neighboring one.
// This powers the "Move to X" action shown on the food-log confirmation toast.
export function suggestOtherMeal(current, date = new Date()) {
  const h = date.getHours();
  if (current === "colazione") return "spuntino";
  if (current === "pranzo")    return h < 13 ? "colazione" : "merenda";
  if (current === "cena")      return h < 19 ? "merenda" : "spuntino";
  if (current === "spuntino") {
    if (h < 12) return "colazione";
    if (h < 18) return "pranzo";
    return "cena";
  }
  if (current === "merenda")   return h < 17 ? "pranzo" : "cena";
  return "pranzo";
}
